import axios from "axios";

const actions = {
  deleteImage: ({ dispatch, state }, imageId) => {
    return axios.delete(`/images/${imageId}`)
      .then((resp) => {
        dispatch("snackbar/successMessage", `Successfully deleted image`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },
  deleteStaticPageImage: ({ state, dispatch }, payload) => {
    dispatch("deleteImage", payload.imageId);

    return axios.delete(`/static-pages/${payload.staticPageId}/images/${payload.ident}`)
      .then((resp) => {
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  deleteStateCityImage: ({ state, dispatch }, payload) => {
    dispatch("deleteImage", payload.imageId);

    return axios.delete(`/locations/images/${payload.ident}`)
      .then((resp) => {
        dispatch("snackbar/successMessage", `Successfully deleted image`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },
  deleteGlobalSettingImage: ({ state, dispatch }, payload) => {
    dispatch("deleteImage", payload.imageId);

    return axios.delete(`/global-settings/images/${payload.ident}`)
      .then((resp) => {
        // snackbar message will go on the deleteImage action
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  }
};

export default {
  actions
};
